import { useState } from "react"
import { Avatar, Box, Divider, Menu, MenuItem } from "@mui/material"
import { useLocation } from "react-router-dom"

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown"

export default function UserMenu({ userData, profilePic, userMenuItems }) {
  const [anchorEl, setAnchorEl] = useState(null)
  const { pathname } = useLocation()

  const isManagementDashboard =
    pathname === "/management-dashboard" ||
    pathname.startsWith("/management-dashboard/")

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleMenuClose = () => {
    setAnchorEl(null)
  }

  const handleAction = (action) => {
    handleMenuClose()
    if (typeof action === "function") action()
  }

  return (
    <>
      <Box
        onClick={handleMenuOpen}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          backgroundColor: isManagementDashboard ? "transparent" : "#474B5266",
          borderRadius: "8px",
          border: isManagementDashboard ? "none" : "1px solid #474B5266",
          p: "8px",
          maxWidth: "95px",
          gap: "10px",
          cursor: "pointer",
        }}
      >
        <Avatar alt="User" src={profilePic} sx={{ width: 32, height: 32 }} />
        <KeyboardArrowDownIcon
          sx={{
            color: isManagementDashboard ? "text.heading" : "white",
            width: 24,
            height: 24,
          }}
        />
      </Box>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        slotProps={{
          paper: {
            sx: {
              borderRadius: "12px",
            },
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            fontWeight: 600,
            px: 2,
            py: 1.5,
            color: "text.menu.heading",
          }}
        >
          <Avatar
            alt={userData?.first_name}
            src={profilePic}
            sx={{ width: 40, height: 40, mr: 1.5 }}
          />
          <Box>
            <Box sx={{ fontWeight: 600, fontSize: "0.95rem" }}>
              {userData?.first_name} {userData?.last_name}
            </Box>
            <Box
              sx={{
                fontSize: "14px",
                fontWeight: 400,
                color: "text.menu.subtext",
              }}
            >
              {userData?.email}
            </Box>
          </Box>
        </Box>

        <Divider />

        {userMenuItems.map((item, idx) =>
          item.divider ? (
            <Divider key={`div-${idx}`} />
          ) : (
            <MenuItem
              key={item.label}
              onClick={() => handleAction(item.action)}
            >
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <item.icon />
                <Box sx={{ ml: 1, color: "text.menu.primary" }}>
                  {item.label}
                </Box>
              </Box>
            </MenuItem>
          )
        )}
      </Menu>
    </>
  )
}
